const prideBodyData = {
    CTA_BAR: {
        COPY: "Stonewall Inn Gives Back Initiative",
        BTN_COPY: "donate",
        BTN_LINK: "https://stonewallinitiative.org/donate",
    },
    CHOSEN_FAMILIES: {
        COPY: "<span class='red-txt'>c</span><span class='orange-txt'>h</span><span class='yellow-txt'>o</span><span class='green-txt'>s</span><span class='blue-txt'>e</span><span class='purple-txt'>n</span> <span class='pink-txt'>f</span><span class='cyan-txt'>a</span><span class='brown-txt'>m</span><span class='red-2-txt'>i</span><span class='orange-2-txt'>l</span><span class='yellow-2-txt'>i</span><span class='green-2-txt'>e</span><span class='purple-2-txt'>s</span> play a critical role for many in the LGBTQ+ community. and they form in safe spaces where people can come together as their authentic selves without the fear of being exposed to discrimination or harassment and with the promise of being accepted and celebrated for who they&nbsp;are."
    },
    COMING_HOME: {
        HEADER: "Coming Home",
        COPY: "to honor LGBTQ+ chosen families, we created a short film, “Coming Home,” which  showcases an LGBTQ+ nightlife space and the chosen families that find each other&nbsp;there.",
        BG_IMAGE: "Coming_Home_FPO@3x.jpg"
    },
    SAFE_SPACES: {
        HEADER: "safe spaces saved",
        COPY: "with many safe spaces in the LGBTQ+ community having to shutter their doors over the last few years, and many others on the verge of closure, bubly is joining forces with The Stonewall Inn Gives Back Initiative (SIGBI) and providing $100,000 to help support the organization’s ongoing efforts to protect safe spaces across the&nbsp;country.<br><br>additionally, bubly is proud to be providing the following LGBTQ+ safe spaces with the funding and support they need to continue their important purpose of connecting the LGBTQ+&nbsp;community:",
        IMG_1: "bubly-logo@3x.png",
        IMG_2: "stonewall-inn-gives-back-initiative@3x.png"
    },
    STONE_WALL: {
        HEADER: "Stonewall Inn Gives Back Initiative",
        COPY: "The Stonewall Inn Gives Back Initiative is a nonprofit charitable organization dedicated to providing educational, strategic and financial assistance to grassroots organizations committed to advocacy for and crucial support to LGBTQ+ communities and individuals who suffer the indignities and fear arising from social intolerance here in the United States and around the&nbsp;world.",
        BTN_COPY: "learn more",
        BTN_LINK: "https://stonewallinitiative.org/",
        IMG_1: "stonewall-inn-gives-back-initiative@3x.png",
        BG_IMAGE: "Mask_Group_26@3x.png"
    },
    PLACES: [
        {
            IMAGE: "TheApartmentLoungeImage.png",
            BG_BUBBLE : "RedBubble@3x.png",
            HEADER: "The Apartment Lounge",
            LOCATION : "Grand Rapids, Michigan",
            BODY : "The Apartment, owned by Bob Johnson, has a rich history spanning four decades and is highly respected in the Grand Rapids community for its fundraising efforts. More than just a bar, it’s the Place Where Friends Meet – whether on their way to the local Civic Theater or for Wednesday Movie&nbsp;Night. ",
            TXT_COLOR : "white-txt",
            BTN_COPY: "learn more",
            BTN_LINK: "https://www.apartmentloungegr.com/"
        },
        {
            IMAGE: "InCahootsNightclub.png",
            BG_BUBBLE : "YellowBubble@3x.png",
            HEADER: "InCahoots<br>Nightclub",
            LOCATION : "Jacksonville, Florida",
            BODY : "Owned by Staci Ybarra, InCahoots has been one of Jacksonville's largest and most popular nightclubs for decades. With all that the club offers its patrons, including dancing, drag shows, a game room, go-go dancers and more, InCahoots represents a community center of sorts for LGBTQ+ people in Northeast&nbsp;Florida.",
            TXT_COLOR : "purple-txt",
            BTN_COPY: "learn more",
            BTN_LINK: "https://www.incahootsnightclub.com/"

        },
        {
            IMAGE: "BoycottBarImage.png",
            BG_BUBBLE : "GreenBubble@3x.png",
            HEADER: "Boycott Bar",
            LOCATION : "Phoenix, Arizona",
            BODY : "Boycott Bar is a safe space for the Phoenix lesbian community and one of only 21 remaining lesbian bars in the country. Owned by Audrey Cooley, Boycott Bar welcomes all its patrons to celebrate their true selves and showcases the best of LGBTQ+ talent and entertainment with nightly DJs, themed events, drag shows and&nbsp;more.",
            TXT_COLOR : "white-txt",
            BTN_COPY: "learn more",
            BTN_LINK: "https://www.instagram.com/boycott_bar/?hl=en"
        },
        {
            IMAGE: "SouthPressCoffee.png",
            BG_BUBBLE : "PurpleBubble@3x.png",
            HEADER: "South Press Coffee",
            LOCATION : "Knoxville, Tennessee",
            BODY : "South Press is a locally sourced, eco-friendly, handcrafted coffee and tea house in Knoxville, TN. Joslynn Fish opened it in 2021 as a sober gathering place for local members of the LGBTQ+ community of all ages. This safe space connects the LGBTQ+ community through live music, artist showcases, coloring nights, and many other activities. It plays a pivotal role in the&nbsp;community.",
            TXT_COLOR : "white-txt",
            BTN_COPY: "learn more",
            BTN_LINK: "https://www.instagram.com/south_press4coffee/?hl=en"

        }
    ]
}

export default prideBodyData


//////////////////
// WEBPACK FOOTER
// ./static/libs/pride-body.js
// module id = null
// module chunks = 